function getContentFromMetaTag(id) {
    const element = document.getElementById(id);

    return element ? element.getAttribute('content') : '';
}

export { getContentFromMetaTag };
